/** Periplo — the new TripGen. */
export const PERIPLO_URL = 'https://www.periploapp.com/trip?new=1';

/** Periplo brand palette (terracotta), matching periploapp.com and the app icon. */
export const PERIPLO_BRAND = {
  main: '#C4603A',
  dark: '#9A4A2D',
  light: '#D88564',
} as const;
